import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandLintasarta({
    height = 24,
    width = 83,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-lintasarta-brand-logo'
                    : 'provider-lintasarta-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandLintasarta"
            width={width}
        />
    );
}

export default AppLogoBrandLintasarta;
